import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import {
  ConcessionProps,
  ConcessionType,
  PaymentConcessionMasterProps
} from '../types';
import { Box, IconButton } from '@mui/material';
import Icons from '../../../components/icons';
import { isEmpty } from 'lodash';

export const getFullPaymentConcessionColumns = (
  activeTab: ConcessionType,
  onEdit: (row: PaymentConcessionMasterProps) => void
): GridColDef[] => {
  const concessionField =
    activeTab === 'rollover'
      ? 'rollOverConcessions'
      : 'newAdmissionConcessions';
  return [
    {
      field: 'grades',
      headerName: 'Grades',
      minWidth: 150,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const grades = params.row.grades;
        return (
          <Box sx={{ display: 'flex', gap: 1 }}>
            {grades.map((grade: string, index: number) => {
              return (
                <Box>
                  {grade}
                  {index === grades.length - 1 ? '' : ','}
                </Box>
              );
            })}
          </Box>
        );
      }
    },
    {
      field: concessionField,
      headerName: `${
        activeTab === 'rollover' ? 'Rollover' : 'New Admission'
      } Concession Added?`,
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: (params) => {
        const concession: ConcessionProps[] = params.row[concessionField];
        return isEmpty(concession) ? <Icons.Close /> : <Icons.Check />;
      }
    },
    {
      field: 'edit',
      headerName: 'Edit',
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <IconButton onClick={() => onEdit(params.row)}>
          <Icons.EditBlackOutlined />
        </IconButton>
      )
    }
  ];
};
